import React from 'react'

export default function AppInput(props) {
    return (
        <div className={`input_div ${props.className ? props.className : ''}`}>
            <input className={'form-control ' + (props.errorMsg !== '' ? 'error' : '') + (props.center === true ? 'text-center' : '')} placeholder={props.placeholder} type={props.inputType} maxLength={props.maxLength} value={props.value} onChange={(e) => props.onChange(e.target.value)} disabled={props.disable} />
            <div className={'invalid-feedback ' + (props.errorMsg !== '' ? 'error' : '')}>{props.errorMsg}</div>
        </div>
    )
}

export function AppInputWithTail(props) {
    return (
        <div className={`input_div ${props.className ? props.className : ''}`}>
            <div className='form-control-with-tail-container'>
                <input className={'form-control form-control-with-tail ' + (props.errorMsg !== '' ? 'error' : '') + (props.center === true ? 'text-center' : '')} placeholder={props.placeholder} type={props.inputType} maxLength={props.maxLength} value={props.value} onChange={(e) => props.onChange(e.target.value)} disabled={props.disable} />
                <div className='form-control-tail'>{props.tail}</div>
            </div>
            <div className={'invalid-feedback ' + (props.errorMsg !== '' ? 'error' : '')}>{props.errorMsg}</div>
        </div>
    )
}